import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./components/header.jsx";
import Main from "./components/main.jsx";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Footer from "./components/footer";

const App = () => {
  return (
    <>
      <ToastContainer className="text-sm" />
      <Header />
      <div className="max-w-7xl w-full m-auto xxxs:py-20 xxs:py-20 xs:py-20 sm:py-20">
        <Routes>
          <Route path="/" element={<Main />} />
        </Routes>
      </div>
      <Footer />
    </>
  );
};

export default App;
